// extracted by mini-css-extract-plugin
module.exports = {"selector":"Selector_selector__1remy","selected":"Selector_selected__27OU-"};